export default __webpack_public_path__ + "static/media/1293.dc2552d8.png";